import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-device-new-peripheral',
  templateUrl: './device-new-peripheral.component.html',
  styleUrls: ['./device-new-peripheral.component.scss']
})
export class DeviceNewPeripheralComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
